module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingStatus),
      expression: "loadingStatus"
    }],
    staticClass: "empty-content",
    attrs: {
      "element-loading-text": "玩命加载中..."
    }
  }, [_c('el-card', [_c('div', {
    staticClass: "content-text"
  }, [_c('h2', [_c('p', [_vm._v("暂无内容")])])])])], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f11a0f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/emptycontent.vue
// module id = 292
// module chunks = 0 10